import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import classNames from "classnames";
import NavbarTop from "components/navbar/top/NavbarTop";
import NavbarVertical from "components/navbar/vertical/NavbarVertical";
// import Footer from "components/footer/Footer";

import { useAppContext } from "Main";
import { useSelector } from "react-redux";
import AuthSimpleLayout from "./AuthSimpleLayout";
import UpdateProfile from "components/ckeditor/GetProfile";
import { appRoutes, dashboardRoutes } from "routes/siteMaps";
import Error404 from "components/errors/Error404";
import ErrorLayout from "./ErrorLayout";
import { Col, Row } from "react-bootstrap";
import ErrorNotAllowed from "components/errors/ErrorNotAllowed";

const MainLayout = () => {

  const loggedUserData = useSelector(state => state.DreamsAdminUser.userData);

  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes("kanban");
  // const isChat = pathname.includes('chat');

  const {
    config: { isFluid, navbarPosition },
  } = useAppContext();

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);








  const findPerm = (routes, currentPath) => {
    // Loop through all routes, including nested ones
    for (let route of routes) {
      if (route.to === currentPath) {
        return route.perm; // Return the perm if the path matches
      }

      // If route has children, recursively check them
      if (route.children) {
        const perm = findPerm(route.children, currentPath);
        if (perm) return perm; // Return the perm from nested routes if found
      }
    }
    return null; // Return null if no matching route is found
  };
  const location = useLocation(); // Get the current URL

  const currentPerm = findPerm(dashboardRoutes.children, location.pathname) || findPerm(appRoutes.children, location.pathname);




  const userPermissions = useSelector(state => state.DreamsAdminUser.userPermissions);


  const [uPermissions, setUpermissions] = useState({});
  useEffect(() => {
    setUpermissions(userPermissions)
  }, [userPermissions])


  if (!loggedUserData?.loginId || !localStorage.getItem('UserAuthToken')) {
    return (
      <AuthSimpleLayout unauth />
    )
  }

  return (
    <div className={isFluid ? "container-fluid" : "container"}>
      {(navbarPosition === "vertical" || navbarPosition === "combo") && (
        <NavbarVertical />
      )}
      <UpdateProfile loginId={loggedUserData?.loginId} />
      <div className={classNames("content", { "pb-0": isKanban })}>
        <NavbarTop />
        {!uPermissions?.[currentPerm] ?
          <Row className="flex-center py-2">
            <Col sm={11} md={9} lg={7} xl={6} className="col-xxl-5">
              {location.pathname === '/reset-password' ?
                <Outlet />
                :
                <ErrorNotAllowed />
              }
            </Col>
          </Row>
          :
          <Outlet />
        }
      </div>
    </div>
  );
};

export default MainLayout;
